import React, { memo } from 'react';
import {
  string, number, arrayOf, shape, object,
} from 'prop-types';
import AmountField from '../../../staticFields/AmountField';
import TipAmountField from '../../../staticFields/TipAmountField';

const CommonOrderAmountsItems = ({
  subTotal, surchargeGroup, currencyCode, cancellationFee,
  processingFee, creditFee, discount, aaDiscount,
  trackingCallback,
  isShowBlankCol, fieldConfig, paymentProcessingFeePaidAmount,
}) => {
  return (
    <React.Fragment>
      <AmountField label="checkout.lib.components.orderDetailContent.subTotal"
        price={subTotal}
        currencyCode={currencyCode}
        {...fieldConfig}
        isShowBlankCol={isShowBlankCol}/>
      <AmountField label="checkout.lib.components.orderDetailContent.discount"
        price={discount}
        currencyCode={currencyCode}
        {...fieldConfig}
        isShowBlankCol={isShowBlankCol}/>
      {
        surchargeGroup && surchargeGroup.length > 0 && surchargeGroup.map(({ name, amount }, index) => {
          return name && <AmountField
            key={index}
            name={name}
            price={amount}
            currencyCode={currencyCode}
            {...fieldConfig}
            isShowBlankCol={isShowBlankCol}/>;
        })
      }
      <AmountField label="checkout.lib.components.orderDetailContent.cancellationFee"
        price={cancellationFee}
        currencyCode={currencyCode}
        {...fieldConfig}
        isShowBlankCol={isShowBlankCol}/>
      <AmountField label="checkout.lib.components.orderDetailContent.creditFee"
        price={creditFee}
        currencyCode={currencyCode}
        {...fieldConfig}
        isShowBlankCol={isShowBlankCol}/>
      <TipAmountField
        label="checkout.lib.components.text.serviceFee"
        tipId="checkout.lib.components.text.serviceFee.tip"
        price={processingFee}
        fieldType={'processingFee'}
        trackingCallback={trackingCallback}
        currencyCode={currencyCode}
        {...fieldConfig}
        isShowBlankCol={isShowBlankCol}/>
      <AmountField label="checkout.lib.components.orderDetailContent.aaDiscount"
        price={aaDiscount}
        currencyCode={currencyCode}
        {...fieldConfig}
        isShowBlankCol={isShowBlankCol}/>
      <AmountField label="checkout.lib.components.orderDetailContent.paidPPF"
        price={paymentProcessingFeePaidAmount}
        currencyCode={currencyCode}
        {...fieldConfig}
        isShowBlankCol={isShowBlankCol}/>
    </React.Fragment>
  );
};

CommonOrderAmountsItems.propTypes = {
  subTotal: number,
  currencyCode: string.isRequired,
  processingFee: number,
  aaDiscount: number,
  discount: number,
  cancellationFee: number,
  creditFee: number,
  surchargeGroup: arrayOf(shape({
    name: string,
    amount: number,
  })),
  fieldConfig: object,
};

CommonOrderAmountsItems.defaultProps = {
  surchargeGroup: [],
  fieldConfig: {},
};

export default memo(CommonOrderAmountsItems);
